import type { en } from '@/i18n/locales/en';
import type { Translation } from '@/i18n/types';

import { accountMenu } from './accountMenu';
import { audit } from './audit';
import { auth } from './auth';
import { challenges } from './challenges';
import { communications } from './communications';
import { documents } from './documents';
import { reports } from './reports';
import { overview } from './overview';
import { common } from './common';
import { companies } from './companies';
import { consents } from './consents';
import { departments } from './departments';
import { editions } from './editions';
import { errors } from './errors';
import { manage } from './manage';
import { managePilots } from './managePilots';
import { manageOverview } from './manageOverview';
import { manageSubscriptions } from './manageSubscriptions';
import { manageSupport } from './manageSupport';
import { nav } from './nav';
import { profile } from './profile';
import { roles } from './roles';
import { shell } from './shell';
import { statistics } from './statistics';
import { subscription } from './subscription';
import { ui } from './ui';
import { users } from './users';
import { participation } from './participation';
import { pilots } from './pilots';
import { settings } from './settings';
import { vitality } from './vitality';

export const es: Translation<typeof en> = {
  common,
  accountMenu,
  nav,
  shell,
  auth,
  profile,
  companies,
  departments,
  users,
  ui,
  roles,
  consents,
  audit,
  statistics,
  subscription,
  manage,
  managePilots,
  manageOverview,
  manageSubscriptions,
  manageSupport,
  editions,
  errors,
  participation,
  pilots,
  vitality,
  settings,
  challenges,
  communications,
  documents,
  reports,
  overview,
};
